import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import styles from "../productPageStyle.js";
import { manufacturerLogoUrl } from "config/images.js";

const useStyles = makeStyles(styles);

/**
 * The desktop-only rail: where you are in the record, and whose product it is.
 *
 * Hidden below 1120px — on a phone the sections are close enough together that
 * a table of contents costs more than it saves, and the mobile page already
 * reads top to bottom in the order the rail lists.
 */
export default function RailNav({ t, product, sections, activeId, onJump }) {
  const classes = useStyles();
  const logo = manufacturerLogoUrl(product.manufacturerLogoUrl);

  return (
    <nav className={classes.rail} aria-label={t.onThisPage}>
      <span className={classes.railLabel}>{t.onThisPage}</span>

      {sections.map((s) => {
        const active = s.id === activeId;
        return (
          <button
            type="button"
            key={s.id}
            className={`${classes.railItem}${
              active ? " " + classes.railItemActive : ""
            }`}
            onClick={() => onJump(s.id)}
          >
            <span
              className={`${classes.railNum}${
                active ? " " + classes.railNumActive : ""
              }`}
            >
              {s.num}
            </span>
            <span
              className={`${classes.railText}${
                active ? " " + classes.railTextActive : ""
              }`}
            >
              {s.label}
            </span>
          </button>
        );
      })}

      {logo && (
        <div className={classes.railBrand}>
          <span className={classes.railLabel} style={{ paddingBottom: 0 }}>
            {t.railBrandLabel}
          </span>
          <img
            className={classes.railBrandLogo}
            src={logo}
            alt={product.manufacturerName || ""}
          />
        </div>
      )}
    </nav>
  );
}
